import { Link as CLink } from '@chakra-ui/react';

// TODO: add jsdoc
export const Link = ({...rest}) => <CLink {...rest} />;
export default Link;
